import Dashboard from "./Home/Dashboard";

function App() {
  return <Dashboard />;
}

export default App;
